import { Send } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";

export const BlastDialog = ({ open, onOpenChange, title, preview, sending, onConfirm }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl" data-testid="blast-preview-dialog">
      <DialogHeader>
        <DialogTitle className="font-syne text-forest">{title || "Launch blast preview"}</DialogTitle>
        <DialogDescription data-testid="blast-preview-subject">
          Subject: <span className="font-semibold text-forest">{preview?.subject}</span>
        </DialogDescription>
      </DialogHeader>
      <div className="w-full min-w-0 overflow-x-auto rounded-xl border border-forest/10 bg-mist">
        <iframe
          title="Launch email preview"
          data-testid="blast-preview-frame"
          srcDoc={preview?.html}
          sandbox=""
          className="h-[380px] w-full min-w-[640px]"
        />
      </div>
      <DialogFooter>
        <button
          type="button"
          data-testid="blast-cancel"
          onClick={() => onOpenChange(false)}
          className="h-11 rounded-full border border-forest/15 px-5 text-sm font-bold text-forest transition-colors hover:border-forest/40"
        >
          Cancel
        </button>
        <button
          type="button"
          data-testid="blast-confirm-send"
          disabled={sending || !preview?.pending}
          onClick={onConfirm}
          className="inline-flex h-11 items-center gap-2 rounded-full bg-fresh px-6 text-sm font-bold text-white transition-colors hover:bg-forest disabled:opacity-50"
        >
          <Send className="h-4 w-4" />
          {sending ? "Sending…" : `Send to ${preview?.pending ?? 0} member${preview?.pending === 1 ? "" : "s"}`}
        </button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
